const show = (el) => {
  el.removeAttribute("aria-hidden");
  el.querySelectorAll("a, button, input").forEach((el) => {
    el.tabIndex = null;
  });
};

const hide = (el) => {
  el.setAttribute("aria-hidden", "true");
  el.querySelectorAll("a, button, input").forEach((el) => {
    el.tabIndex = -1;
  });
};

class ProductCarouselEditorial extends HTMLElement {
  constructor() {
    super();
    this.sliderEl = this.querySelector("[data-slider]");
    this.prevButton = this.querySelector("[data-prev]");
    this.nextButton = this.querySelector("[data-next]");
  }

  connectedCallback() {
    window.loadSwiper.then(({ Swiper }) => {
      this.swiper = new Swiper(this.sliderEl, {
        slidesPerView: "auto",
        speed: 250,
        loop: false,
        allowTouchMove: true,
        watchSlidesProgress: true,
        pagination: {
          clickable: true,
          enabled: true,
          el: ".swiper-pagination",
        },
        breakpoints: {
          1024: {
            spaceBetween: 24,
            // slidesOffsetAfter: window.innerWidth * 0.067,
            pagination: {
              enabled: false,
            },
          },
        },
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
        on: {
          lock: () => {
            if (this.prevButton) this.prevButton.style.display = "none";
            if (this.nextButton) this.nextButton.style.display = "none";
          },
          unlock: () => {
            if (this.prevButton) this.prevButton.style.display = null;
            if (this.nextButton) this.nextButton.style.display = null;
          },
          slideChangeTransitionStart: () => {
            this.swiper.slides.forEach((slide) => {
              hide(slide);
            });
          },
          slideChangeTransitionEnd: () => {
            window.requestAnimationFrame(() => {
              this.swiper.slides.forEach((slide) => {
                slide.classList.contains("swiper-slide-visible")
                  ? show(slide)
                  : hide(slide);
              });
            });
          },
        },
      });

      this.swiper.slides.forEach((slide) => {
        slide.classList.contains("swiper-slide-visible")
          ? show(slide)
          : hide(slide);
      });
    });
  }
}

if (!customElements.get("product-carousel-editorial")) {
  customElements.define("product-carousel-editorial", ProductCarouselEditorial);
}
